import React, { createContext, useEffect, useState, useRef } from 'react'
import { Table, Form, Button, Alert, message, ConfigProvider, Empty, Checkbox, Tooltip, Popover, Divider } from 'antd'
import { getColumns } from './components/columns'
import { shopLogClstag } from '../shop/log'
import { erpLogClstag } from '../erp/log'
import { resSetCode, Status } from './components/columns/type'
import ApplyModal from './components/applyModal'
import AcorePagination from '../pager'

export const TableContext = createContext({} as any)
export const UserFeedbackComContext = createContext(null)
export const AppTypeContext = createContext(null)

const MaterialTable = (props) => {
  const {
    onChange = () => {},
    type = 'shop',
    contorlItems = [],
    dataSource,
    sucHeaderList = [],
    save = () => {},
    batchSave = () => {},
    onSearch = () => {},
    loading = false,
    pagination,
    showFeedBack = () => {},
    needBatchSave = true,
    apiUrl = {
      getImgZoneSort: () => {},
      getImgZoneList: () => {},
      uploadImgZone: '',
    },
    needBatchApply = true,
    searchMaxWidth,
    spuFlow,
    isProd,
    SwitchTab,
  } = props
  const [form] = Form.useForm()
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [columns, setColumns] = useState([])
  const [visible, setVisible] = useState(false)
  const [firstComeIn, setFirstComeIn] = useState(false)
  const [data, setData] = useState([])
  const updateConfig = useRef({
    status: true, // true 全部更新 false 不更新
    skuId: '', // skuId 有值时 只更新id
  })

  useEffect(() => {
    const isFirst = localStorage.getItem('BatchBtnFirst')
    setFirstComeIn(isFirst === '1' ? false : true)
    localStorage.setItem('BatchBtnFirst', '1')
  }, [])

  useEffect(() => {
    if (sucHeaderList && sucHeaderList.length) {
      setColumns(sucHeaderList.map((item) => getColumns(item, updateConfig, isProd)))
    }
  }, [sucHeaderList, data])

  useEffect(() => {
    setData([])
    if (dataSource && dataSource.length) {
      updateConfig.current = {
        status: true,
        skuId: '',
      }
      setData([...dataSource])
    }
  }, [dataSource])

  const updateData = ({ status, skuId }) => {
    updateConfig.current = {
      status,
      skuId,
    }
    setData([...data])
  }

  const editMutApplyRes = (res, out) => {
    if (res && res.length) {
      res.forEach((item) => {
        data.forEach((i) => {
          if (i.skuId === item.skuId) {
            resSetCode.forEach((code) => {
              const postFormData = out.filter((s) => i.skuId === s.skuId)[0]
              if (i[code]) {
                i[code].value = postFormData[code]
              } else {
                i[code] = {
                  value: postFormData[code],
                }
              }
              i.skuMaterialStatus = Status['审核中']
              i.editorStatus = false
              if (item[code] && item[code].failReason && i[code]) {
                i[code].failReason = item[code].failReason
                i[code].status = 5
                i.skuMaterialStatus = Status['审核失败']
                i.editorStatus = true
              } else {
                i[code].failReason = ''
                i[code].status = 3
              }
            })
            if (i['smartPicTransparent']) {
              i['smartPicTransparent'].failReason = ''
            }
            if (i['smartPicWhite']) {
              i['smartPicWhite'].failReason = ''
            }
          }
        })
      })
      updateData({ status: false, skuId: out.map((i) => i.skuId).join(',') })
    } else {
      data.forEach((i) => {
        out.forEach((item) => {
          if (item.skuId === i.skuId) {
            i.skuMaterialStatus = Status['审核中']
            i.editorStatus = false
          }
        })
      })
      updateData({ status: false, skuId: '' })
    }
  }

  const validateItem = (item) => {
    return new Promise((s) => {
      form
        .validateFields(item)
        .then((e) => {
          s(e)
        })
        .catch((r) => {
          if (!r.errorFields.length) {
            s(r.values)
          } else {
            s(false)
          }
        })
    })
  }

  const getSaveData = (item, key) => {
    const saveMap = {
      skuId: data[+key].skuId,
    }
    Object.keys(item).forEach((i) => {
      saveMap[i.split('-')[1]] = item[i]
    })
    return saveMap
  }

  // 情况：不是全部校验通过的情况
  const partApply = async (rowItemsMaps) => {
    const keys = Object.keys(rowItemsMaps)
    const len = Object.keys(rowItemsMaps).length
    const outArr = []
    for (let index = 0; index < len; index++) {
      const element = rowItemsMaps[keys[index]]
      const iData = await validateItem(element)
      if (iData) {
        outArr.push(getSaveData(iData, keys[index]))
      }
    }
    if (outArr.length) {
      batchSave(outArr, (res) => {
        if (res) {
          editMutApplyRes(res, outArr)
        }
      })
    }
  }

  const onFinish = () => {
    const formNames = sucHeaderList.filter((item) => item.formItem).map((item) => item.id)
    // 暂时特殊处理下
    if (formNames.some((i) => i === 'smartContentSell')) {
      formNames.push(...['smartContentSell2', 'smartContentSell3'])
    }
    const formItemNames = []
    const rowItemsMaps = {}
    data.forEach((item, index) => {
      if (item.editorStatus) {
        formNames.forEach((i) => {
          formItemNames.push(`${index}-${i}`)
        })
        rowItemsMaps[index] = formNames.map((i) => `${index}-${i}`)
      }
    })
    if (formItemNames.length) {
      form
        .validateFields(formItemNames)
        .then((r) => {
          const out = []
          data.forEach((item, index) => {
            if (item.editorStatus) {
              const postForm = {
                skuId: item.skuId,
              }
              formNames.forEach((i) => {
                postForm[i] = r[`${index}-${i}`]
              })
              out.push(postForm)
            }
          })
          batchSave(out, (res) => {
            if (res) {
              editMutApplyRes(res, out)
            }
          })
        })
        .catch(() => {
          partApply(rowItemsMaps)
        })
    } else {
      message.error('无可更新素材')
    }
  }
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys([...newSelectedRowKeys])
  }

  const rowSelection = {
    selectedRowKeys,
    renderCell: (checked, record) => {
      return (
        <span clstag="pageclick|keycount|supplement_material_1667200329665|1">
          <Checkbox
            checked={checked}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedRowKeys([...selectedRowKeys, record.skuId])
              } else {
                setSelectedRowKeys([...selectedRowKeys.filter((i) => i !== record.skuId)])
              }
            }}
          ></Checkbox>
        </span>
      )
    },
    onChange: onSelectChange,
  }

  const firstContent = () => {
    return (
      <div style={{ width: 200 }}>
        <div style={{ color: 'rgba(0, 0, 0, 0.65)' }}>
          商品素材批量维护功能上线啦，批量勾选商品后，点击”批量完善”按钮，即可批量上传素材。
        </div>
        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <Button type="primary" style={{ borderRadius: 5 }} onClick={() => setFirstComeIn(false)}>
            我知道了
          </Button>
        </div>
      </div>
    )
  }

  return (
    <div>
      <div style={{ margin: '10px 10px', display: 'flex', justifyContent: 'space-between' }}>
        <props.Search
          onChange={onSearch}
          searchMaxWidth={searchMaxWidth}
          contorlItems={contorlItems}
          type={type}
          spuFlow={spuFlow}
        />
      </div>
      <Divider style={{ marginTop: 14 }} />
      <div style={{ display: 'flex' }}>
        {needBatchApply && (
          <Popover
            content={firstContent()}
            title={<span style={{ color: '#FF4C4C', fontSize: 16 }}>功能上新！</span>}
            visible={firstComeIn}
          >
            <Tooltip placement="top" title={selectedRowKeys && !selectedRowKeys.length ? '请选择需要完善的商品' : ''}>
              <span style={{ position: 'relative', display: 'inline-block' }}>
                <img
                  style={{ width: 45, position: 'absolute', left: 0, top: '-11px', zIndex: 10 }}
                  src="https://img13.360buyimg.com/imagetools/jfs/t1/127303/16/27063/1660/62480228E66e7c01c/1a8fe2e86c39e709.png"
                />
                <Button
                  type="primary"
                  disabled={selectedRowKeys && !selectedRowKeys.length}
                  style={{ marginRight: 15, borderRadius: 40 }}
                  onClick={() => setVisible(true)}
                  clstag={type === 'shop' ? shopLogClstag['batchApplyClick'] : erpLogClstag['batchApplyClick']}
                >
                  批量完善
                </Button>
              </span>
            </Tooltip>
          </Popover>
        )}
        {needBatchSave && (
          <Button
            type="primary"
            onClick={() => onFinish()}
            clstag={type === 'shop' ? shopLogClstag['mutSaveBtnClick'] : erpLogClstag['mutSaveBtnClick']}
            style={{ borderRadius: 40 }}
          >
            批量保存
          </Button>
        )}
        <div style={{ marginLeft: 'auto' }}>{SwitchTab}</div>
      </div>
      <TableContext.Provider
        value={{ ...apiUrl, form, uploadImgUrl: props.uploadImgUrl, updateData, save, showErpFeedBack: () => {}, data }}
      >
        <Form form={form} className="custom-info-table">
          <AppTypeContext.Provider value={type}>
            <ApplyModal
              visible={visible}
              setVisible={setVisible}
              batchSave={batchSave}
              selectedRowKeys={selectedRowKeys}
              editMutApplyRes={editMutApplyRes}
            />
            <UserFeedbackComContext.Provider value={type === 'shop' ? showFeedBack : null}>
              <ConfigProvider
                renderEmpty={() => (
                  <Empty description={<div>暂无可维护商品</div>} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                )}
              >
                <Table
                  rowKey={(record) => record.skuId}
                  rowSelection={rowSelection}
                  columns={columns}
                  dataSource={data}
                  loading={loading}
                  scroll={{ x: 1200 }}
                  pagination={false}
                />
              </ConfigProvider>
              <div style={{ textAlign: 'right', margin: '16px 0' }}>
                <AcorePagination
                  total={pagination.total}
                  onChange={onChange}
                  // onShowSizeChange={onShowSizeChange}
                  current={pagination.current}
                  showSizeChanger={true}
                  // pageSize={resource.pageSize}
                  defaultCurrent={1}
                  defaultPageSize={10}
                  pageSizeOptions={[10, 20, 50]}
                  showTotal={(total) => `共 ${total} 条数据`}
                />
              </div>
            </UserFeedbackComContext.Provider>
          </AppTypeContext.Provider>
        </Form>
      </TableContext.Provider>
    </div>
  )
}

export default MaterialTable
